import { Component, computed, input, inject, viewChild } from '@angular/core';
import { PersonVisitRecordsStore } from './person-visit-records.store';
import {
    dateFromColumnWithTime,
    dateToColumnWithTime,
    dayDateFromColumn,
    filesColumn,
    performedProceduresColumn,
    usersChipColumn,
} from '../../../../shared/components/kit/table/table.fields';
import { TableColumn, TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { router, translate } from '../../../../shared/shared.global-service';
import { workUri } from '../../../../../utils/router.utils';
import { workGridItemFrag } from './person-visit-records.query';
import { WorkGridItemObject } from '@it2go/types';
import { getWorkDistinctVouchers } from '../../../../../utils/work.utils';
import { FilterBuilder } from '../../../helper/filter.builder';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import {
    WorkLengthPipe,
} from '../../../../../components/medical-service/work/pages/work-visits-page/work-visits-page.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { WorkPrintService } from '../../../../../components/medical-service/work/work-print.service';
import {
    WORK_PRINT_ALL_TYPES,
} from '../../../../../components/medical-service/work/work-print-dialog/work-print-dialog.types';
import { WorkExportScopeEnum } from '@libs/types/src/services/enum/work-export.enum';
import { featureOn } from '../../../../../feature-flag';

@Component({
    selector: 'app-person-visit-records',
    templateUrl: 'person-visit-records.component.html',
    providers: [PersonVisitRecordsStore],
    imports: [
        TableComponent,
        WorkLengthPipe,
        PrimeTemplate,
        ButtonComponent,
    ],
})
export class PersonVisitRecordsComponent {
    protected readonly store = inject(PersonVisitRecordsStore);
    protected readonly workPrint = inject(WorkPrintService);
    protected readonly table = viewChild(TableComponent);
    protected readonly extendedWorkExportsEnabled = featureOn.EXTENDED_WORK_EXPORTS;


    public folderId = input.required<number>();

    protected extraFilters = computed(() => {
        return FilterBuilder.filter({
            folderIdWithSharing: [this.folderId()],
        }).filter;
    });

    protected columns: TableColumn[] = [
        {
            name: 'workType',
            data: (item: any) => translate.instant(`workData.common.enum.type.${item}`),
        },
        dayDateFromColumn,
        dateFromColumnWithTime,
        dateToColumnWithTime,
        {
            name: 'workData.note',
            type: TableColumnType.String50,
        },
        { name: 'visitLength' },
        performedProceduresColumn,
        {
            name: 'vouchers',
            dataKey: null,
            data: (item: WorkGridItemObject) => {
                return getWorkDistinctVouchers(item);
            },
            type: TableColumnType.Vouchers,
            voucherOptions: { showDetail: true, maxWidth: 'initial' },
        },
        {
            dataKey: 'person.insurances.0.insuranceAbbr',
            name: 'insuranceAbbr',
            filterable: true,
        },
        usersChipColumn,
        filesColumn,
    ];

    detail(item: any): void {
        router.navigateByUrl(workUri({ workType: item?.workType, id: item.id }, item.serviceId)).then();
    }

    protected readonly workGridItemFrag = workGridItemFrag;
    protected readonly supportedPrintTypes = WORK_PRINT_ALL_TYPES;

    public printRecords(): void {
        this.workPrint.openBulk({
            selection: this.table()?.selection(),
            supportedWorkTypes: this.supportedPrintTypes,
            dateFrom: null,
            dateTo: null,
            folderIds: [this.folderId()],
            scope: WorkExportScopeEnum.FOLDER_WITH_SHARING,
        });
    }

    protected printRecord(item: WorkGridItemObject): void {
        this.workPrint.openRow(item, {
            folderIds: [this.folderId()],
            scope: WorkExportScopeEnum.FOLDER_WITH_SHARING,
        });
    }
}
